<template>
  <div>
    <v-dialog v-model="dialog"
              persistent
              scrollable
              width="800"
    >

      <v-card>

        <v-card-title>
          Ajouter des cartes GIFTY par excel
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">


          <v-alert dismissible
                   text
                   type="error" prominent
                   dense
                   v-if="errors_400 && errors_400.length"
          >
            <ul class="ma-0 pa-0 pl-4">
              <li v-for="(err, i) in errors_400" :key="i">
                {{ err }}
              </li>
            </ul>
          </v-alert>


          <v-select v-model="form.client"
                    :error-messages="errors.client"
                    item-value="account.id"
                    clearable
                    :items="clients"
                    item-text="name"
                    outlined
                    background-color="grey lighten-5"
                    label="Client *"/>

          <v-select v-model="form.template"
                    :error-messages="errors.template"
                    item-value="id"
                    clearable
                    :items="templates"
                    item-text="title"
                    outlined
                    background-color="grey lighten-5"
                    label="Modèle *"/>

          <v-file-input outlined
                        ref="file"
                        :error-messages="errors.file"
                        accept=".xlsx,.xls"
                        chips
                        label="Excel *"
                        show-size
                        @change="uploadFile"
                        @focus="errors && errors.file ? (errors.file = '') : false"
          />

          <v-alert type="info" text>
            <strong>Format attendu du fichier Excel :</strong>
            <ul class="ma-0 pa-0 pl-4">
              <li>Colonne 1 : <strong>Téléphone +213xxxxxxxxx</strong></li>
              <li>Colonne 2 : <strong>Montant</strong> (numérique, ex: 1000, 7000)</li>
            </ul>
          </v-alert>

        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn dark
                 color="gifty"
                 :loading="isLoading"
                 depressed
                 @click="saveData">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
  </div>
</template>

<script>

import {HTTP} from "@/http-common";

export default {
  props: ['templates', 'databases','clients'],
  data() {
    return {
      isLoading: false,
      dialog: false,
      form: {
        file: "",
        template: "",
        client: "",
      },
      errors: {},
      errors_400: null,
    }
  },
  methods: {
    uploadFile(file) {
      this.form.file = file;
    },
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.resetForm()
    },
    saveData() {
      this.errors = {}
      this.errors_400 = null
      this.isLoading = true

      const formData = new FormData()

      formData.append('file', this.form.file ?? "")
      formData.append('template', this.form.template ?? "")
      formData.append('client', this.form.client ?? "")

      HTTP.post('/v1/account-cards/store-by-excel', formData).then(() => {
        this.isLoading = false
        this.dialog = false
        this.$emit('refresh')
        this.$successMessage = "Le solde a été ajouté et un traitement est en cours.";
        this.resetForm()
      }).catch(err => {
        this.isLoading = false

        this.errors = {}
        this.errors_400 = null

        const status = err.response?.status
        const data = err.response?.data

        if (status === 422) {
          this.errors = data.errors || {}
        } else if (status === 400) {
          this.errors_400 = data.data.errors || []
        } else {
          console.error(err)
        }

        this.$errorMessage = "Une erreur s'est produite, veuillez corriger et réessayer."
        console.log(err)
      })
    },

    resetForm() {
      this.form.file = ""
      this.form.template = ""
      this.form.client = ""
      this.errors = {}
    }
  }
}
</script>
<style>
.c .v-chip:not(.v-chip--active),
.c .v-chip:not(.v-chip--active) .v-icon {
  background: #d60c56 !important;
  color: white !important;
}
</style>
